// Types
import type { Action } from "./types";

/**
 * @param {*} data
 * @return {*}  {Action}
 */
export const fetchBhaBrokers = (data: any): Action => ({
  type: "FETCH_BHA_BROKERS",
  data,
});

/**
 * @param {*} data
 * @return {*}  {Action}
 */
export const updateBhaBrokers = (data: any): Action => ({
  type: "UPDATE_BHA_BROKERS",
  data,
});

/**
 * @return {*}  {Action}
 */
export const fetchFullBrokers = (): Action => ({
  type: "FETCH_FULL_BROKERS",
});

/**
 * @param {*} data
 * @return {*}  {Action}
 */
export const updateFullBrokers = (data: any): Action => ({
  type: "UPDATE_FULL_BROKERS",
  data,
});

/**
 * @param {*} data
 * @return {*}  {Action}
 */
export const createBroker = (data: any): Action => ({
  type: "CREATE_BROKER",
  data,
});

/**
 * @param {*} data
 * @return {*}  {Action}
 */
export const editBroker = (data: any): Action => ({
  type: "EDIT_BROKER",
  data,
});

/**
 * @param {*} data
 * @return {*}  {Action}
 */
export const updateBroker = (data: any): Action => ({
  type: "UPDATE_BROKER",
  data,
});

/**
 * @return {*}  {Action}
 */
export const getBroker = (): Action => ({
  type: "GET_BROKER",
});

/**
 * @return {*}  {Action}
 */
export const clearBroker = (): Action => ({
  type: "CLEAR_BROKER",
});

export const clearAllBrokers = (): Action => ({
  type: "CLEAR_ALL_BROKERS",
});

/**
 * @desc fetch a single broker's person record for the details panel
 * @param {*} data broker person guid
 * @return {*}  {Action}
 */
export const fetchBrokerDetails = (data: any): Action => ({
  type: "FETCH_BROKER_DETAILS",
  data,
});

/**
 * @param {*} data
 * @return {*}  {Action}
 */
export const editBrokerDetails = (data: any): Action => ({
  type: "EDIT_BROKER_DETAILS",
  data,
});

/**
 * @desc patch a broker's contact information and address
 * @param {*} data
 * @return {*}  {Action}
 */
export const updateBrokerDetails = (data: any): Action => ({
  type: "UPDATE_BROKER_DETAILS",
  data,
});

/**
 * @return {*}  {Action}
 */
export const clearBrokerDetails = (): Action => ({
  type: "CLEAR_BROKER_DETAILS",
});
